import { collection } from 'typesaurus';
export const likes = collection('likes');
